// extracted by mini-css-extract-plugin
export default {"centered":"style--centered--e6097b","right":"style--right--aad129","noWrap":"style--noWrap--cb9327"};